import * as React from 'react';
import { useState } from 'react';
import DateTimeHover from '../date_time_component/DateTime';
import { UserName } from '../name_component/user/UserNameComponent';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import ServiceCallRevisionViewerModal from '../service_call_revision_viewer_modal/ServiceCallRevisionViewerModal';

interface Props {
	serviceCall: any;
	workOrder: any;
}

const findContactForEmail = (serviceCall: any, email?: string) => {
	if (!email) return null;
	const candidates = [
		nullSafeGet('checkOutByContact', serviceCall),
		nullSafeGet('checkInByContact', serviceCall),
		nullSafeGet('leadTechnicianEmailContact', serviceCall),
	];
	return candidates.find((contact) => contact && contact.email === email) || null;
};

const ServiceCallRevisionsDropdown: React.FC<Props> = ({ serviceCall, workOrder }) => {
	const revisions = nullSafeGetOrElse('revisionChanges', serviceCall, []);
	const [open, setOpen] = useState(false);

	// Only show when there's at least one prior revision to compare against;
	// the latest revision matches the live service call card, so it's not useful on its own.
	if (revisions.length <= 1) {
		return null;
	}

	const latest = [...revisions].sort((left, right) => right.revision - left.revision)[0];
	const revisedByContact = findContactForEmail(serviceCall, latest.revisedBy);

	return (
		<span className="footnoteregular" style={{ color: 'rgba(0,0,0,0.45)' }}>
			Edited by{' '}
			{revisedByContact ? (
				<UserName mode={'inline'} contact={revisedByContact} />
			) : (
				latest.revisedBy
			)}{' '}
			<DateTimeHover timestamp={latest.revisedAt} />.{' '}
			<a onClick={() => setOpen(true)} style={{ textDecoration: 'underline' }}>
				Revision History
			</a>
			<ServiceCallRevisionViewerModal
				visible={open}
				onCancel={() => setOpen(false)}
				revisions={revisions}
				serviceCall={serviceCall}
				workOrder={workOrder}
			/>
		</span>
	);
};

export default ServiceCallRevisionsDropdown;
